import { createStandardAction } from 'typesafe-actions'
import * as Sentry from '@sentry/browser'

import { ThunkResult } from './types'
import { getAuthState, parseJwt, getAllocationMap, getSubscriptionStatus } from '../util/helpers'
import isProduction from '../standalone/isProduction'
import { initializeWtaClient } from '../analytics/wtaAnalytics'
import { productMap, getViewContext } from '../analytics/helpers'
import { OWL } from '../types'
import { getJwt } from '../util/jwtLocalstorage'
import { googleApiInitialized } from './dependencies'
import { clearJwt, clearLegacyCookie } from '../util/jwtLocalstorage'
import wfeTokenRefresh from '../util/wfeTokenRefresh'

export const ActionTypes = {
  PAGE_VIEW: 'PAGE_VIEW',
  APP_INITIALIZING: 'APP_INITIALIZING',
  APP_INITIALIZED: 'APP_INITIALIZED',
}

export const pageView = createStandardAction(ActionTypes.PAGE_VIEW)()

const getLogEventLambdaEndPoint = () =>
  isProduction() ? 'https://fn.chegg.com/log/log-event-v2-batch' : 'https://fn.test.cheggnet.com/log/log-event-v2-batch'

export const initializeAnalytics = () => {
  const token = getJwt()

  if (token) {
    const parsedToken = parseJwt(token)
    const { cheggUserUuid, site, paidMember } = parsedToken
    if (site === OWL) return

    initializeWtaClient({
      endpoint: getLogEventLambdaEndPoint(),
      authState: getAuthState(cheggUserUuid),
      cheggUuid: cheggUserUuid || undefined,
      staging: !isProduction(),
      property: site,
      appId: 'wfe',
      testCells: getAllocationMap(),
      subscriptions: [{ product: productMap[site], status: getSubscriptionStatus(paidMember) }],
      errorHandler: Sentry.captureException,
      view: getViewContext(site),
    })
  }
}

export const initializeConfiguration: ThunkResult<void> = async (
  dispatch,
  getState,
  { config, gapi, pusherClient }
) => {
  const { site, app: { upload, pasteOnly, initRSW, initFreshToken } } = getState()

  dispatch({ type: ActionTypes.APP_INITIALIZING })

  config.init({
    upload,
  })
  config.setSite(site)
  clearLegacyCookie()
  try {
    if (!pasteOnly) {
      await gapi.init()
      await gapi.onApiLoad()
      dispatch(googleApiInitialized())
    }

    if (initFreshToken) {
      clearJwt()
      await wfeTokenRefresh()
    }
  } catch (e) {
    Sentry.captureMessage(`Error in app initialization: ${JSON.stringify(e)}`)
  }

  dispatch({
    type: ActionTypes.APP_INITIALIZED,
    config: {
      debug: config.debug,
      environment: config.environment,
      upload,
      site,
    },
  })

  if (initRSW) {
    dispatch(pageView())
    initializeAnalytics()
  }
}
